import { useContext } from 'react';
import { PermissionEn } from 'src/constants/permission.enum';
import { AppContext } from 'src/contexts/app.context';
import type { IResourceFullAccessDetail } from 'src/types/master_data/userResource.type';
import { useBasePath } from './useBasePath';

function usePermission({ path }: { path?: string }) {
  const { resources } = useContext(AppContext);
  const basePath = useBasePath();

  const getListPermission = () => {
    let _path = path ?? basePath;

    const permissions = resources?.find(
      (x) => x?.path === _path || x?.path === _path?.replace('ticket-raising', 'help-desk')
    )?.permissions;
    return permissions;
  };

  const listPermission = getListPermission();
  const isRead = listPermission?.includes(PermissionEn.read);
  const isViewDetail = listPermission?.includes(PermissionEn.viewDetail);
  const isCreate = listPermission?.includes(PermissionEn.create);
  const isUpdate = listPermission?.includes(PermissionEn.update);
  const isDelete = listPermission?.includes(PermissionEn.delete);
  const isApprove = listPermission?.includes(PermissionEn.approve);
  const isReject = listPermission?.includes(PermissionEn.reject);
  const isApprove_solution = listPermission?.includes(PermissionEn.approve_solution);
  const isAssign = listPermission?.includes(PermissionEn.assign);
  const isCreate_leave_ticket = listPermission?.includes(PermissionEn.create_leave_ticket);
  const isAdmin = listPermission?.includes(PermissionEn.admin);
  const isGet_qr = listPermission?.includes(PermissionEn.get_qr);
  const isConfig_field = listPermission?.includes(PermissionEn.config_field);
  const isConfirm_transportation = listPermission?.includes(PermissionEn.confirm_transportation);

  return {
    isRead,
    isViewDetail,
    isCreate,
    isUpdate,
    isDelete,
    isApprove,
    isReject,
    isApprove_solution,
    isAssign,
    isCreate_leave_ticket,
    isAdmin,
    isGet_qr,
    isConfig_field,
    isConfirm_transportation
  };
}

export function usePermissionNew(
  paths?: string[],
  resourcesParam?: IResourceFullAccessDetail[],
  ticketCategoryCode?: string
) {
  const { resources } = useContext(AppContext);
  const basePath = useBasePath();
  const resourceList = resourcesParam ?? resources;

  const getPermissions = () => {
    if (ticketCategoryCode) {
      const permission = resourceList?.find((x) => x?.hrTicketCategoryCode === ticketCategoryCode);
      return permission ? [permission] : [];
    }

    if (!paths) {
      const permission = resourceList?.find((x) => x?.path === basePath);
      return permission ? [permission] : [];
    }

    return paths.map((path) => resourceList?.find((x) => x?.path === (path ?? basePath))).filter(Boolean);
  };

  return getPermissions();
}

export default usePermission;
